module.exports = __webpack_public_path__ + "img/x-twitter.0a7485c0.svg";